<template>
  <v-app>
    <div id="app">
      <v-container>
        <Navbar/>
        <router-view />
        <v-snackbar
          v-model="snackbar.open"
          :color="snackbar.success ? 'success' : 'error'"
          :right="true"
          :top="true"
          :timeout="5000"
        >{{ snackbar.message }}</v-snackbar>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import Navbar from "@/components/shared/Navbar"
export default {
  components: {
    Navbar
  },
  methods: {
    signup() {
      this.$store.dispatch("signup", {
        email: this.email,
        password: this.password
      });
    }
  },
  computed: {
    snackbar() {
      return this.$store.getters.snackbar
    }
  }
};
</script>
